// extracted by mini-css-extract-plugin
export default {"link_report":"ReportBtn_link_report__r+I9b","diagramsvg":"ReportBtn_diagramsvg__jW4-w"};